import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://auth.yuuu.es';

const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    // Save acceptance in localStorage
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-container">
        <p className="cookie-consent-text">
          {t('policies.cookieConsent')}{' '}
          <a href={`${SSO_URL}/legal/cookies?lang=${i18n.language}`}
             target="_blank" rel="noopener noreferrer"
             className="cookie-consent-link">
            {t('policies.moreInfo', 'More info')}
          </a>
        </p>
        <button className="cookie-consent-button" onClick={handleAccept}>
          {t('policies.acceptButton')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
